export default __webpack_public_path__ + "static/media/description_24px.6ed46016.svg";